export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/mezzoforte-icon.svg?baf7ed6b2a8c2e326ac2f66757fe3fa1";